var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#df4440",
    height: 48,
    rx: 4,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 29.821v1.576c0 4.133-7.544 5.599-14 5.599s-14-1.466-14-5.6v-1.575c3.13 1.92 7.897 2.979 14 2.979s10.87-1.059 14-2.979zm0-8.4v1.575c0 4.133-7.544 5.599-14 5.599s-14-1.466-14-5.6v-1.574c3.13 1.92 7.897 2.978 14 2.978s10.87-1.059 14-2.978zM24 9c6.456 0 14 1.466 14 5.6 0 4.132-7.54 5.598-14 5.598S10 18.732 10 14.6 17.544 9 24 9z",
    fill: "#fffffe"
  }))));
}
export default SvgDatasetFill;